import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchStaffAttendanceReportData } from "../../../../redux/reducers/apiSlice";
import TableSkeleton from "../../../common-components/TableSkeleton";
import { convertTo12HourFormat } from "../../../common-data/Converts";
import { BodyBuilder } from "../../../../exports/Images";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import { stringToColor } from "../../../../data/Constants";
import { ReloadIcon } from "../../../../images/icons/icons";

const TrainerAttendance = ({
  userInfoData,
  prevFilters,
  setModValues,
  trainerAttendanceRef,
  closeSection,
}) => {
  const dispatch = useDispatch();
  const { staff_atttendance_loading, staff_atttendance_report } = useSelector(
    (state) => state.api
  );

  const iniFilters = {
    gym_id: prevFilters?.gym_id || "",
    account_type: "trainer",
    date_from: prevFilters?.date_from || "",
    date_to: prevFilters?.date_to || "",
    checkin_time_filter: prevFilters?.checkin_time_filter || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [allAttendanceData, setAllAttendanceData] = useState([]);

  function getAllStaffAttendanceReport(filters) {
    dispatch(
      fetchStaffAttendanceReportData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (filters?.gym_id) {
      getAllStaffAttendanceReport(filters);
    }
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: prevFilters?.gym_id || "",
      date_from: prevFilters?.date_from || "",
      date_to: prevFilters?.date_to || "",
      checkin_time_filter: prevFilters?.checkin_time_filter || "",
    }));
  }, [
    prevFilters?.gym_id,
    prevFilters?.date_from,
    prevFilters?.date_to,
    prevFilters?.checkin_time_filter,
  ]);

  useEffect(() => {
    if (
      staff_atttendance_report?.status &&
      staff_atttendance_report?.data?.length > 0
    ) {
      setAllAttendanceData(staff_atttendance_report.data);
    } else {
      setAllAttendanceData([]);
    }
  }, [staff_atttendance_report]);

  const tbColumns = [
    {
      dataField: "name",
      text: "Trainer",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer">
          {row?.profile ? (
            <img
              src={row?.profile || BodyBuilder}
              alt={row?.name || "N/A"}
              className="image"
              onClick={() =>
                row?.profile &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "image_view",
                  image: row?.profile,
                  rowData: row,
                }))
              }
            />
          ) : (
            <div
              className="nameInitials"
              style={{ backgroundColor: stringToColor(row?.name || "") }}
            >
              <span className="nameLetters">
                <span className="nameLetters">
                  {row?.name
                    ?.split(" ")
                    .map((namePart, index) =>
                      index === 0 || index === row?.name?.split(" ").length - 1
                        ? namePart.charAt(0).toUpperCase()
                        : null
                    )}
                </span>
              </span>
            </div>
          )}
          <span className="tb-data text-start">
            {row?.name || "NA"}
            <br />
            {(row?.mobile || row?.email) && (
              <small className="lowercase">
                {row?.mobile || ""}
                <br />
                {row?.email || ""}
              </small>
            )}
          </span>
        </div>
      ),
    },
    {
      dataField: "shift_details",
      text: "Shift 1",
      formatter: (_, row) => {
        const shiftDetails = row?.shift_details ? row.shift_details?.[0] : {};
        const startTime = shiftDetails?.start_time
          ? convertTo12HourFormat(shiftDetails.start_time)
          : "-";
        const endTime = shiftDetails?.end_time
          ? convertTo12HourFormat(shiftDetails.end_time)
          : "-";

        const attendanceDetails = shiftDetails?.attendance_details || {};
        const { checkin_image, checkout_image } = attendanceDetails;
        const checkinStatus =
          attendanceDetails?.checkin_status?.toLowerCase().replace(/ /g, "_") ||
          "";

        const checkinTime =
          attendanceDetails?.checkin_time &&
          attendanceDetails?.checkin_time !== "N/A"
            ? convertTo12HourFormat(attendanceDetails.checkin_time)
            : "";
        const checkoutTime =
          attendanceDetails?.checkout_time &&
          attendanceDetails?.checkout_time !== "N/A"
            ? convertTo12HourFormat(attendanceDetails.checkout_time)
            : "";

        const attendanceStatus = attendanceDetails?.status
          ?.replace(/ /g, "_")
          .toLowerCase();

        const checkinReport =
          attendanceDetails?.status &&
          attendanceStatus !== "n/a" &&
          attendanceStatus !== "not_checked_in"
            ? attendanceDetails?.status?.toLowerCase()
            : "";

        const checkinReportTime =
          attendanceDetails?.shift_difference &&
          attendanceDetails?.shift_difference !== "N/A" &&
          attendanceDetails?.status !== "On Time"
            ? attendanceDetails.shift_difference
            : "";

        const shiftName = shiftDetails?.shift_name || "";

        const isAbsent =
          checkinStatus === "day_off" ||
          checkinStatus === "on_leave" ||
          checkinStatus === "not_checked_in" ||
          checkinStatus === "absent";

        return (
          <div className="multi-tb-data-container minWidth220">
            {checkinStatus && (
              <small
                style={{
                  color: checkinStatus === "checked-in" ? "#09AA51" : "#CC0A39",
                }}
              >
                {checkinStatus.replace(/_/g, " ")}
              </small>
            )}

            {!isAbsent && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  rowGap: "5px",
                }}
              >
                {checkinTime && (
                  <small
                    className={`link`}
                    onClick={() =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "checkin_image",
                        image: checkin_image,
                        rowData: row,
                      }))
                    }
                  >
                    checkin - <b>{checkinTime}</b>{" "}
                    {checkinReport && (
                      <small
                        style={{
                          color:
                            checkinReport === "late" ? "#CC0A39" : "#3B66D6",
                        }}
                      >
                        ({checkinReport}{" "}
                        {checkinReportTime ? `${checkinReportTime}` : ""})
                      </small>
                    )}
                  </small>
                )}

                {checkoutTime && (
                  <small
                    className={`link`}
                    onClick={() =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "checkout_image",
                        image: checkout_image,
                        rowData: row,
                      }))
                    }
                  >
                    checkout - <b>{checkoutTime}</b>
                  </small>
                )}
              </div>
            )}

            {(startTime || endTime) && (
              <small className="underline">
                {startTime} - {endTime}
              </small>
            )}

            {shiftName && (
              <span
                className="info"
                style={{
                  padding: "5px 10px",
                  backgroundColor:
                    shiftName?.toLowerCase() === "evening"
                      ? "#4793AF"
                      : "#FF9800",
                }}
              >
                {shiftName}
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "shift_details",
      text: "Shift 2",
      formatter: (_, row) => {
        const shiftDetails = row?.shift_details ? row.shift_details?.[1] : {};
        const startTime = shiftDetails?.start_time
          ? convertTo12HourFormat(shiftDetails.start_time)
          : "-";
        const endTime = shiftDetails?.end_time
          ? convertTo12HourFormat(shiftDetails.end_time)
          : "-";

        const attendanceDetails = shiftDetails?.attendance_details || {};
        const { checkin_image, checkout_image } = attendanceDetails;
        const checkinStatus =
          attendanceDetails?.checkin_status
            ?.toLowerCase()
            ?.replace(/ /g, "_") || "";

        const checkinTime =
          attendanceDetails?.checkin_time &&
          attendanceDetails?.checkin_time !== "N/A"
            ? convertTo12HourFormat(attendanceDetails.checkin_time)
            : "";
        const checkoutTime =
          attendanceDetails?.checkout_time &&
          attendanceDetails?.checkout_time !== "N/A"
            ? convertTo12HourFormat(attendanceDetails.checkout_time)
            : "";

        const attendanceStatus = attendanceDetails?.status
          ?.replace(/ /g, "_")
          .toLowerCase();

        const checkinReport =
          attendanceDetails?.status &&
          attendanceStatus !== "n/a" &&
          attendanceStatus !== "not_checked_in"
            ? attendanceDetails?.status?.toLowerCase()
            : "";

        const checkinReportTime =
          attendanceDetails?.shift_difference &&
          attendanceDetails?.shift_difference !== "N/A" &&
          attendanceDetails?.status !== "On Time"
            ? attendanceDetails.shift_difference
            : "";

        const shiftName = shiftDetails?.shift_name || "";

        const isAbsent =
          checkinStatus === "day_off" ||
          checkinStatus === "on_leave" ||
          checkinStatus === "not_checked_in" ||
          checkinStatus === "absent";

        return (
          <div className="multi-tb-data-container minWidth220">
            {checkinStatus && (
              <small
                style={{
                  color: checkinStatus === "checked-in" ? "#09AA51" : "#CC0A39",
                }}
              >
                {checkinStatus.replace(/_/g, " ")}
              </small>
            )}

            {!isAbsent && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  rowGap: "5px",
                }}
              >
                {checkinTime && (
                  <small
                    className={`link`}
                    onClick={() =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "checkin_image",
                        image: checkin_image,
                        rowData: row,
                      }))
                    }
                  >
                    checkin - <b>{checkinTime}</b>{" "}
                    {checkinReport && (
                      <small
                        style={{
                          color:
                            checkinReport === "late" ? "#CC0A39" : "#3B66D6",
                        }}
                      >
                        ({checkinReport}:{" "}
                        {checkinReportTime ? `${checkinReportTime}` : ""})
                      </small>
                    )}
                  </small>
                )}

                {checkoutTime && (
                  <small
                    className={`link`}
                    onClick={() =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "checkout_image",
                        image: checkout_image,
                        rowData: row,
                      }))
                    }
                  >
                    checkout - <b>{checkoutTime}</b>
                  </small>
                )}
              </div>
            )}

            {(startTime || endTime) && (
              <small className="underline">
                {startTime} - {endTime}
              </small>
            )}

            {shiftName && (
              <span
                className="info"
                style={{
                  padding: "5px 10px",
                  backgroundColor:
                    shiftName?.toLowerCase() === "evening"
                      ? "#4793AF"
                      : "#FF9800",
                }}
              >
                {shiftName}
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            account_type="button"
            className="actionBtn icon view withText"
            disabled={false}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                rowData: row,
              }))
            }
          >
            view details
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="mr-full-width-section" ref={trainerAttendanceRef}>
      <div className="mr-section-header">
        <div className="mr-section-header-left">
          <h2 className="mr-section-title">Trainer Attendance</h2>
          <p className="mr-section-subtitle">
            Trainer attendance details and shift information
          </p>
        </div>
        <div className="mr-section-header-right">
          <button
            className="mr-section-reload-btn"
            onClick={() => getAllStaffAttendanceReport(filters)}
            title="Reload data"
          >
            {ReloadIcon()}
          </button>
          <button
            className="mr-section-close-btn"
            onClick={closeSection}
            title="Close section"
          >
            ×
          </button>
        </div>
      </div>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt-0 mb30">
        {staff_atttendance_loading ? (
          <TableSkeleton columns={12} rows={20} />
        ) : (
          <PaymentLinkTable
            tableData={allAttendanceData}
            tableColumns={tbColumns}
          />
        )}
      </div>
    </div>
  );
};

export default TrainerAttendance;
